HomeController.$inject = ["API_URL", "$http", "$rootScope", "DaysToCountService", "TimeslotService", "FixedHeadingService", "$location", "$filter"];

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

angular.module('calendarApp').controller('HomeController', HomeController);

function HomeController(API_URL, $http, $rootScope, DaysToCountService, TimeslotService, FixedHeadingService, $location, $filter) {
  var home = this; // The customer has been directed to this calendar type. Store the calendar type - the user will always be directed to this
  // calendar.

  localStorage.setItem('calendar-type', 'CLASS');
  home.init =
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee() {
    var loggedIn, appointments, unreserve, searchParams, date, timeslotParams;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            home.finishedLoading = false;
            $rootScope.timeSettings = smooth.timeSettings;
            loggedIn = !!($rootScope.customerInfo && $rootScope.customerInfo.email); // Remove modal background if it's there

            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
            delete $rootScope.newAppointments;
            localStorage.removeItem('payment-state'); // If there are previously reserved appointments, delete them as it will cause a mess
            // if the user chooses a new service

            appointments = localStorage.getItem('reserved-appointments');

            try {
              appointments = JSON.parse(appointments);
            } catch (e) {
              localStorage.removeItem('reserved-appointments');
              appointments = null;
            } // Delete all tentative appointments against the customer


            _context.prev = 9;
            _context.t0 = loggedIn && appointments && appointments.length;

            if (!_context.t0) {
              _context.next = 15;
              break;
            }

            _context.next = 14;
            return $http.put(API_URL + '/api/v1/calendar/appointment/unreserve', {
              appointments: appointments
            });

          case 14:
            _context.t0 = _context.sent;

          case 15:
            unreserve = _context.t0;
            localStorage.removeItem('reserved-appointments');
            _context.next = 22;
            break;

          case 19:
            _context.prev = 19;
            _context.t1 = _context["catch"](9);
            console.error("Error unreserving appointments");

          case 22:
            searchParams = $location.search();
            home.chosenService = searchParams.serviceid || '1';
            home.chosenResource = searchParams.resourceid || '1';
            home.chosenDate = searchParams.date || null;
            date = $location.search().date; // date supplied as ?date= param

            if (date && moment(date).isSameOrAfter(moment())) {
              home.startDate = moment(date);
            } else {
              home.startDate = moment();
            }

            timeslotParams = {
              startdate: home.startDate.format('YYYY-MM-DD'),
              daystocount: DaysToCountService.getDaysToCount()
            };

            if (home.chosenService !== '1') {
              timeslotParams.serviceid = home.chosenService;
            }

            if (home.chosenResource !== '1') {
              timeslotParams.resourceid = home.chosenResource;
            }

            $rootScope.throbber && $rootScope.throbber.show();
            TimeslotService.getTimeslots(timeslotParams).then(function (response) {
              home.finishedLoading = true;
              $rootScope.throbber && $rootScope.throbber.hide();

              if (!response.success) {
                $rootScope.throbber && $rootScope.throbber.showError($filter('calendarLabel')('Sorry but an error occurred with this request'));
                console.error('Sorry but an error occurred with this request');
                return;
              }

              home.days = response.days;
              home.daysAvailable = response.daysAvailable;
              home.resources = response.resources;
              home.startDate = home.days.length ? moment(home.days[0].date) : moment();
              home.services = response.services;
              FixedHeadingService.fixHeading();
            }, function (error) {
              $rootScope.throbber && $rootScope.throbber.showError($filter('calendarLabel')('Sorry but an error occurred with this request: ' + error.msg));
              console.error('Sorry but an error occurred with this request');
            });

          case 33:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[9, 19]]);
  })); // end init

  home.init();

  home.filterService = function () {
    var params = {
      startdate: home.startDate.format('YYYY-MM-DD'),
      daystocount: DaysToCountService.getDaysToCount()
    };

    if (home.chosenService !== '1') {
      params.serviceid = home.chosenService;
    } // Reset the chosen resource


    home.chosenResource = '1';
    $rootScope.throbber.show();
    TimeslotService.getTimeslots(params).then(function (response) {
      $rootScope.throbber.hide();

      if (!response.success) {
        $rootScope.throbber.showError($filter('calendarLabel')('Sorry but an error occurred with this request:' + error.data.msg));
        return;
      }

      home.days = response.days;
      home.daysAvailable = response.daysAvailable;
      home.resources = response.resources;
      home.services = response.services;
      home.startDate = home.days.length ? moment(home.days[0].date) : moment();
      $location.search('resourceid', null);

      if (home.chosenService !== '1') {
        $location.search('serviceid', home.chosenService);
      } else {
        $location.search('serviceid', null);
      }
    }, function (error) {
      $rootScope.throbber.showError($filter('calendarLabel')('Sorry but an error occurred with this request:' + error.data.msg));
      throw new Error(error);
    });
  };

  home.filterResource = function () {
    var params = {
      startdate: home.startDate.format('YYYY-MM-DD'),
      daystocount: DaysToCountService.getDaysToCount()
    };

    if (home.chosenResource !== '1') {
      params.resourceid = home.chosenResource;
    } // Always filter on the service


    if (home.chosenService !== '1') {
      params.serviceid = home.chosenService;
    }

    TimeslotService.getTimeslots(params).then(function (response) {
      if (!response.success) {
        // $rootScope.throbber.showError(response.msg);
        return;
      }

      home.days = response.days;
      home.resources = response.resources;
      home.services = response.services;
      home.daysAvailable = response.daysAvailable;
      home.startDate = home.days.length ? moment(home.days[0].date) : moment();

      if (home.chosenResource !== '1') {
        $location.search('resourceid', home.chosenResource);
      } else {
        $location.search('resourceid', null);
      }
    }, function (error) {
      $rootScope.throbber.showError($filter('calendarLabel')('Sorry but an error occurred with this request'));
      throw new Error(error);
    });
  }; // Called by the datepicker


  home.dateChanged = function (date) {
    var params = {
      startdate: date,
      daystocount: DaysToCountService.getDaysToCount()
    };

    if (home.chosenService !== '1') {
      params.serviceid = home.chosenService;
    }

    if (home.chosenResource && home.chosenResource !== '1') {
      params.resourceid = home.chosenResource;
    }

    $rootScope.throbber.show();
    $http.get(API_URL + '/api/v1/calendar/timeslots/' + smooth.orgid, {
      params: params
    }).then(function (reply) {
      $rootScope.throbber.hide();
      var response = reply.data;

      if (!response.success) {
        $rootScope.throbber.showError($filter('calendarLabel')('Sorry but an error occurred with this request'));
        console.error(response.msg);
        return;
      }

      home.days = response.timeslots;
      home.startDate = home.days.length ? moment(home.days[0].date) : moment();
      $location.search('date', moment(home.days[0].date).format('YYYY-MM-DD'));
    }, function (error) {
      $rootScope.throbber.showError($filter('calendarLabel')('Sorry but an error occurred with this request'));
      throw new Error(error);
    });
  }; // Remember that the days displayed may not be consecutive.
  // So if we're moving, we want to start at the day *after* the last one that is currently
  // being shown.


  home.moveDays = function (direction) {
    var daysToMove = DaysToCountService.getDaysToCount(); // Determine startDate

    var startDate;

    if (direction === 'forward') {
      // Get the date from the last of the currently showing days
      startDate = home.days[home.days.length - 1].date; // Add one day as starting point

      startDate = moment(startDate).add(1, 'days').format('YYYY-MM-DD');
    } else {
      startDate = home.days[0].date;
    }

    if (moment(startDate).isSameOrBefore(home.daysAvailable[0]) || moment(startDate).isSameOrAfter(home.daysAvailable[home.daysAvailable.length - 1])) {
      return;
    }

    var params = {
      startdate: startDate,
      daystocount: daysToMove,
      direction: direction
    };

    if (home.chosenService !== '1') {
      params.serviceid = home.chosenService;
    }

    if (home.chosenResource !== '1') {
      params.resourceid = home.chosenResource;
    }

    $rootScope.throbber && $rootScope.throbber.show();
    $http.get(API_URL + '/api/v1/calendar/timeslots/' + smooth.orgid, {
      params: params
    }).then(function (reply) {
      $rootScope.throbber && $rootScope.throbber.hide();
      var response = reply.data;

      if (!response.success) {
        $rootScope.throbber && $rootScope.throbber.showError($filter('calendarLabel')('Sorry but an error occurred with this request'));
        console.error(response.msg);
        return;
      }

      home.days = response.timeslots;
      home.startDate = home.days.length ? moment(home.days[0].date) : moment();
      $location.search('date', moment(home.days[0].date).format('YYYY-MM-DD'));
      FixedHeadingService.fixHeading();
    }, function (error) {
      $rootScope.throbber.showError($filter('calendarLabel')('Sorry but an error occurred with this request'));
      throw new Error(error);
    });
  };
}